import * as React from 'react';
import clsx from 'clsx';
import { IconButton, type IconButtonProps } from '@hungryroot/ui-kit';
import { Bookmark } from '@hungryroot/ui-kit';

import styles from './FavoriteGroceries.module.css';

const getButtonVariant = (args: {
  variant?: Pick<IconButtonProps, 'prominence' | 'style' | 'size'>;
  disabled?: boolean;
}) => {
  const {
    variant = {
      size: 'small',
      style: 'inverted',
      prominence: 'primary',
    },
    disabled,
  } = args;

  return {
    ...variant,
    style: disabled ? 'disabled' : variant.style,
  };
};

interface FavoriteGroceriesIconProps {
  ariaLabel: string;
  className: string;
  disabled: boolean;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  testid?: string;
  variant?: Pick<IconButtonProps, 'prominence' | 'style' | 'size'>;
}

export function FavoriteGroceriesIcon({
  ariaLabel,
  className,
  disabled,
  onClick,
  testid,
  variant,
}: FavoriteGroceriesIconProps) {
  return (
    <IconButton
      ariaLabel={ariaLabel}
      className={clsx(className, styles['pdp-variant'])}
      icon={<Bookmark />}
      onClick={onClick}
      testid={testid}
      {...getButtonVariant({ disabled, variant })}
    />
  );
}
